import { Grid } from '@chakra-ui/react';

import { CustomShareableCardSkeleton } from './CustomShareableCardSkeleton';

export const MediaKitsLoadingGrid = () => (
  <Grid
    templateColumns={{
      base: '1fr',
      md: '1fr 1fr',
      lg: '1fr 1fr 1fr 1fr',
    }}
    gap={6}
    data-testid="media-kits-loading-grid"
  >
    {Array(8)
      .fill(0)
      .map((_, index) => (
        <CustomShareableCardSkeleton key={index} />
      ))}
  </Grid>
);
